/**
 * Product Form Components
 *
 */
 class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.template = this.form.querySelector('[type="button"]').getAttribute('data-redirect-template');
    this.couponCode = this.form.querySelector('[type="button"]').getAttribute('data-coupon') || null;
    if (this.form.getAttribute('data-template') != 'index' && this.form.getAttribute('data-template') != 'page' && this.form.getAttribute('data-template') != 'product' && this.form.getAttribute('data-template') != 'article') {
      if (!this.form.querySelector('[type="button"]')) return;
      this.form.querySelector('[type="button"]').addEventListener('click', this.onSubmitHandler.bind(this));
    } else if (this.form.getAttribute('data-template') == 'product') {
      if (!this.form.querySelector('[type="button"]')) return;
      if (this.form.querySelector('[type="button"]').getAttribute('data-product-type') == 'subscription') {
        this.form.querySelector('[type="button"]').addEventListener('click', this.getProduct.bind(this));
      } else {
        this.form.querySelector('[type="button"]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
    } else {
      if (!this.form.querySelector('[type="button"]')) return;
      if (this.form.querySelector('[type="button"]').getAttribute('data-product-type') == 'subscription') {
        this.form.querySelector('[type="button"]').addEventListener('click', this.getProduct.bind(this));
      } else {
        this.form.querySelector('[type="button"]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
    }
    this.cartElement = document.querySelector('ajax-cart');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    this.shopCollLink = document.querySelector('#shop-coll-link');
    if (window.globalVariables.template == 'product') {
      if (this.shopCollLink.childNodes.length == 0) {
        document.querySelector('#shop-more-div').classList.add('d-none');
      } else {
        document.querySelector('#shop-more-div').classList.remove('d-none')
      }
    }
  }

  /**
   * Get Product which is already in cart
   * Check if it is in cart then show error meassage
   * Otherwise Submit the product form event
   */

  getProduct(e) {
    const productId = this.querySelector('[type="button"]').getAttribute('data-productid');

    const cartProduct = window.globalVariables.cart.find((x) => x.product_id == productId);
    if (cartProduct != undefined) {
      notificationEle.updateNotification('Error', 'Your cart already contains this subscription.', {
        type: 'error',
        timeout: 3000
      });
    } else {
      this.onSubmitHandler(e);
    }
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    const submitButton = this.querySelector('[type="button"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    var eventCurrency = submitButton.getAttribute('data-tiktok-currency');
    var eventContentName = submitButton.getAttribute('data-tiktok-content_name');
    var vendorName = submitButton.getAttribute('data-productvendor');
    var eventContent_ids = this.form.getAttribute('data-productid');
    var ttclid = Utility.getCookie('ttclid');
    var productPrice = evt.target.closest('[data-tiktok-price]').getAttribute('data-tiktok-price') / 100;
    var GAPrice =  evt.target.closest('[data-tiktok-price]').getAttribute('data-tiktok-price') / 100.0;
    var event_id;
    // var offerProdId = this.querySelector('[data-subid]') != null ? this.querySelector('[data-subid]').value : null;
    var items = [];
    var properties = {};

    var isCheckout;
    if (submitButton.getAttribute('data-redirect-checkout')) {
      isCheckout = submitButton.getAttribute('data-redirect-checkout');
    }

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form))
    });

    // this.querySelectorAll('input[name*="properties"]').forEach(ele => {
    //   const name = ele.name.replace('properties[', '').replace(']', '');
    //   properties[name] = ele.value;
    // });
    
    // let mainproduct = {
    //     id: this.querySelector('[name="id"]').value,
    //     properties: properties
    // };

    // if(this.querySelector('input[name*="selling_plan"]') != null){
    //   mainproduct.selling_plan = this.querySelector('input[name*="selling_plan"]').value;
    // }

    // items.push(mainproduct);

    // if(offerProdId != null){
    //   let offerproduct = {
    //       id: offerProdId,
    //       properties: {
    //           parent_id: this.querySelector('[name="id"]').value
    //       }
    //   };
    //   items.push(offerproduct);
    // }

    // let body = JSON.stringify({items: items});

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {

        if(document.querySelector('#PopupModal-quickshop')){
          document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
        }
        fetch('/cart.json', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(data => {
          let res = data.json();
          res.then((result) => {
            document.querySelector('[data-item_count]').innerHTML = result.items.length;
            if (isCheckout === 'true') {
              // this._redirectToCheckout();
              event_id = 'AddToCart'+eventContent_ids;
              tiktok._tiktokS2SEvent('AddToCart', eventContent_ids, result.items[0].quantity, '', window.location.href, productPrice, eventContentName, event_id);
              
              event_id = 'Subscribe'+eventContent_ids;
              tiktok._tiktokS2SEvent('Subscribe', eventContent_ids, result.items[0].quantity, '', window.location.href, productPrice, eventContentName, event_id);
              
              event_id = 'InitiateCheckout'+eventContent_ids;
              tiktok._tiktokS2SEvent('InitiateCheckout', eventContent_ids, result.items[0].quantity, '', window.location.href, productPrice, eventContentName, event_id);
              this.cartElement.getCartData();
              this._tiktokTwitterEvent(ttclid, eventContent_ids, eventCurrency, eventContentName, productPrice, event_id);


              dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
              dataLayer.push({
                event: "add_to_cart",
                ecommerce: {
                  currency: window.theme.currency,
                  value: `${GAPrice}`,
                  items: [
                  {
                    item_id: eventContent_ids,
                    item_name: `${eventContentName}`,
                    affiliation: "Google Merchandise Store",
                    index: 0,
                    item_brand: `${vendorName}`,
                    item_variant: this.querySelector('input[name="id"]').value,
                    price: `${GAPrice}`,
                    quantity: qtyInput
                  }
                  ]
                }
              });
              

              if (window.globalVariables.templateName == 'page.subscribe') {
                /* Start ViewContent Tiktok Event code: */
                  event_id = 'ViewContent' + '9644203976' + eventContent_ids;
                  ttq.track('ViewContent', {
                    contents: [{
                      content_id: eventContent_ids,
                      content_name: eventContentName,
                      quantity: result.items[0].quantity,
                      price: productPrice,
                    }],
                    event_id: event_id,
                    content_type: 'product_group',
                    value: window.globalVariables.total_price/100,
                    currency: eventCurrency,
                  });
                  tiktok._tiktokS2SEvent('ViewContent', eventContent_ids, result.items[0].quantity, '', window.location.href, productPrice, eventContentName, event_id);
                /* End ViewContent Event code: */
              }

              if(this.couponCode != null){
                window.location.href = `/checkout?discount=${this.couponCode}`;
              } else {
                window.location.href = '/checkout';
              }

              localStorage.setItem('gift_enabled', false);
            } else {
              this.cartElement.getCartData('open_upsell');
              event_id = 'AddToCart'+eventContent_ids;
              tiktok._tiktokS2SEvent('AddToCart', eventContent_ids, result.items[0].quantity, '', window.location.href, productPrice, eventContentName, event_id);
              this.cartElement.getCartData('open_drawer');
            }
             /* Start AddToCart Tiktok Event code: */
             event_id = 'AddToCart'+eventContent_ids;
             ttq.track('AddToCart', {
              contents: [{
                content_id: eventContent_ids,
                content_name: eventContentName,
                quantity: result.items[0].quantity,
                price: productPrice,
              }],
              event_id: event_id,
              content_type: 'product_group',
              value: window.globalVariables.total_price /100,
              currency: eventCurrency,
            });
            /* End AddToCart Event code: */

             /* Start AddToCart Pinterest Event code: */
             pintrk('track', 'AddToCart', {
              currency: eventCurrency,
              value: (result.total_price)/100,
              order_quantity: result.items[0].quantity
            });
            /* End AddToCart Event code: */

            /* Start Twitter - Add to cart conversion tracking event code: */
            twq('event', 'tw-o0dof-od9cb', {
              value: productPrice, // use this to pass the value of the conversion (e.g. 5.00)
              currency: eventCurrency // use this to pass the currency of the conversion with an ISO 4217 code (e.g. ‘USD’)
            });
            /* End Twitter - Add To Cart Event code: */

          });
        });
        
        if(qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setTimeout(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        }, 2000);
    });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;

    if(action == 'decrease' && currentQty <= 1){
      return false;
    }else if(action == 'decrease'){
      finalQty = currentQty - 1;
    }else{
      finalQty = currentQty + 1;
    } 
    $qtyInput.value = finalQty;
  }

  /* Redirect to Recharge checkout */

  _redirectToCheckout() {
    function reChargeGetCookie(name) {
      return (document.cookie.match(`(^|; )${name}=([^;]*)`) || 0)[2];
    }
  
    // Build the Checkout URL
    let ga_linker = '';
    const myshopify_domain = 'battlboxllc.myshopify.com';
    const token = reChargeGetCookie('cart');
    try {
      // Cross-domain tracking with Google Analytics
      ga_linker = '&' + ga.getAll()[0].get('linkerParam');
    } catch (e) {
      // 'ga' is not available
      ga_linker = '';
    }
    // Customer email address for use in the Checkout URL
    const customer_param = window.theme.customersID ? `&customer_id=${window.theme.customersID}&customer_email=${window.theme.emailHashed}` : '';
    var checkout_url;
    // if ( this.template == 'page.bf-50-off-new' || this.template == 'page.fb-duplicate' || this.template == 'page.event-banner-promotions' || this.template == 'page.fb-duplicate-2' || this.template == 'page.fb new test - WH' || this.template == 'page.fb' || this.template == 'page.fb-4plans' || this.template == "page.fb_BOGO" ) {
    if(this.couponCode != null){
      checkout_url = `https://checkout.battlbox.com/r/checkout?myshopify_domain=${myshopify_domain}&cart_token=${token}${ga_linker}${customer_param}&discount=${this.couponCode}`;
    } else {
      checkout_url = `https://checkout.battlbox.com/r/checkout?myshopify_domain=${myshopify_domain}&cart_token=${token}${ga_linker}${customer_param}`;
    }

    window.location.href = checkout_url;
    localStorage.setItem('gift_enabled', false);
  }

  /* InitiateCheckout Tiktok Event */
  _tiktokTwitterEvent(ttclid, eventContent_ids, eventCurrency, eventContentName, productPrice, event_id){
    ttq.track('InitiateCheckout', {
      contents: [{
        content_id: eventContent_ids,
        concontent_name: eventContentName,
        quantity: 1,
        price: productPrice,
      }],
      event_id: event_id,
      content_type: 'product_group',
      value: window.globalVariables.total_price/100,
      currency: eventCurrency,
    });

    event_id = 'Subscribe' + eventContent_ids;
    ttq.track('Subscribe', {
      contents: [{
        content_id: eventContent_ids,
        concontent_name: eventContentName,
        quantity: 1,
        price:  productPrice,
      }],
      event_id: event_id,
      content_type: 'product_group',
      value: window.globalVariables.total_price/100,
      currency: eventCurrency,
    });

    /** Twitter - Subscribe conversion tracking event code */
    twq('event', 'tw-o0dof-od9ce', {
      value: productPrice, // use this to pass the value of the conversion (e.g. 5.00)
      currency: eventCurrency // use this to pass the currency of the conversion with an ISO 4217 code (e.g. ‘USD’)
    });
  }
}

customElements.define('product-form', ProductForm);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.emailPopUp = this.form.querySelector('[data-bst_trigger]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;

    if(this.formType == 'product-page') this.onVariantChange('load');  
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange(_event) {
    this.setCurrentVariant();
    if (!this.currentVariant) {
      this.toggleAddButton('disable', this.currentVariant);
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid); 
      }else{
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable',this.currentVariant);
    }

    if (document.querySelectorAll('[data-product-container] [data-subscription_price]').length) {
      document.querySelectorAll('[data-product-container] [data-subscription_price]').forEach((ele)=>{
        ele.innerHTML=Shopify.formatMoney(this.currentVariant.selling_plan_allocations[0].price, window.globalVariables.money_format)
      })
    }

    if(_event != 'load')  {
      rechargeWidget.prototype._toggleOptions(_event);

      _event.target.closest('[data-product-grid],[data-product-container]').querySelectorAll('[data-subscription_price],[data-select-subscription_price]').forEach((ele)=>{
        let subscription_price=Shopify.formatMoney(this.currentVariant.selling_plan_allocations[0].price, window.globalVariables.money_format)
        if (ele.closest('[data-select-subscription_price]')) {
          let text=ele.innerText.split(window.globalVariables.money_format.replaceAll('{{amount}}',''));
          ele.innerText=`${text[0]} ${subscription_price}`
        }else{
          ele.innerHTML=subscription_price;
        }
      })
      _event.target.closest('[data-product-grid],[data-product-container]').querySelectorAll('[data-onetime-price],[data-select-onetime-price]').forEach((ele)=>{
        
        let onetime_price=Shopify.formatMoney(this.currentVariant.price, window.globalVariables.money_format)
        if (ele.closest('[data-select-onetime-price]')) {
          let text=ele.innerText.split(window.globalVariables.money_format.replaceAll('{{amount}}',''));
          ele.innerText=`${text[0]} ${onetime_price}`
        }else{
          ele.innerHTML=onetime_price;
        }
      });
      
    }
    
  }

  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = '?variant=' + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    return options;
  }

  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
   
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });
      
      // assign variant details to this.currentVariant if all options are present
      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
        return;
      }
    });
  }

  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;

    // Price Update
    let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
    let compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if(priceElement) priceElement.innerHTML = price;
    if(comparePriceElement) comparePriceElement.innerHTML = compare_price;

    // Grid Image Update on variant selection
    if(this.formType == 'grid'){
      if(!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src;
      if(updatedSrc && featuredImage){
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    }else{
      if(!currentVariant.featured_image) return;
      let imageID = currentVariant.featured_image.id;
      let imageSlide = document.querySelector(`.product--image[data-imageID="${imageID}"]`);
      if(this.formType == 'quickshop'){
        imageSlide = document.querySelector(`.quickshop-slider .product--image[data-imageID="${imageID}"]`);
      }
      if(!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      if(quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if(productSlider)  productSlider.slideTo(slideIndex, 2000, true);
    }

    // Variant name update
    let options = this.form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let lableID = 'option'+option.dataset.optionindex;
      const lable = option.querySelector('.selected-option');
      if(!lable || !lableID) return;
      lable.innerHTML = currentVariant[lableID];
    });
  }

  toggleAddButton(status, variant) {
    if (status == 'disable') {
      if (this.addBtn) {
        this.addBtn.setAttribute('disabled', true);
        this.addBtn.classList.add('btn-disabled');
      }
      if (this.emailPopUp) {
        this.emailPopUp.classList.remove('d-none');
        this.emailPopUp.setAttribute('data-variant-id',variant.id);
      }
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
    } else if(this.currentVariant && !this.currentVariant.available) {
      if (this.addBtn) {
        this.addBtn.setAttribute('disabled', true);
        this.addBtn.classList.add('btn-disabled');
      }
      if (this.emailPopUp) {
        this.emailPopUp.classList.remove('d-none');
        this.emailPopUp.setAttribute('data-variant-id',variant.id);
      }
    
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      if (this.addBtn) {
        this.addBtn.removeAttribute('disabled');
        this.addBtn.classList.remove('btn-disabled');
      }
      if (this.emailPopUp) {
        this.emailPopUp.classList.add('d-none');
      }
      if (this.addBtn.querySelector('.add-text') && this.closest('.cart-drawer-upsell')) {
        this.addBtn.querySelector('.add-text').textContent = "Add";
      } else if (this.addBtn.querySelector('.add-text')) {
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      }
    };
  }

  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      });
    }
  }
}
customElements.define('variant-radios', VariantRadios);

class rechargeWidget extends HTMLElement {
  constructor() {
    super();

    const optionSelectors = this.querySelectorAll('[data-purchase_type]');
    optionSelectors.forEach(option => option.addEventListener('click', this._toggleOptions.bind(this)));

    const sellingPlans=this.querySelectorAll('[data-purchase_type="subscription"] select');
    sellingPlans.forEach(plan => plan.addEventListener('change', this._changeSellingPlan.bind(this)));

  }
  _toggleOptions(event){
    let form=event.target.closest('form');
    if (form.closest('[data-product-container]') && form.querySelector('recharge-widget')) {
      this.variantsData=JSON.parse(form.querySelector('[data-variantJSON]').innerText);
      let type=form.querySelector('[name="selling_plan"]:checked')?.closest('[data-purchase_type]')?.getAttribute('data-purchase_type');
      document.querySelector('[data-purchase_type].selected')?.classList.remove('selected');
      document.querySelector(`[data-purchase_type="${type}"]`)?.classList.add('selected');
    }
  }

  _changeSellingPlan(event){
    let id=event.target.value;
    event.target.closest('[data-purchase_type]').querySelector('[name="selling_plan"]').value=id;
  }
}
customElements.define('recharge-widget', rechargeWidget);